import type { ButtonProps } from '@mui/material/Button';
import Button from '@mui/material/Button';
import { grey } from '@mui/material/colors';
import React from 'react';

const LinkButton = (props: ButtonProps) => {
  return (
    <Button
      size='small'
      variant='text'
      {...props}
      sx={{
        color: grey[900],
        fontWeight: 'normal',
        textDecoration: 'underline',
        backgroundColor: 'transparent',
        '&:hover': {
          textDecoration: 'none',
          backgroundColor: 'transparent',
        },
        ...props.sx,
      }}
    />
  );
};

export default LinkButton;
